import * as yup from "yup";

export const referralTypeSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
